function initFeaturedSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 4,
    perMove: 1,
    gap: '30px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1600: { perPage: 5 },
      1199: { perPage: 5 },
      1024: { perPage: 3, gap: '15px' },
      768: { perPage: 2.5 },
      575: {
        perPage: 2,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });

  splide.mount();

  slider.classList.add('splide--featured-initialized');
}

function autoInitFeaturedSliders(scope = document) {
  scope.querySelectorAll('.fps-splide').forEach((slider) => {
    initFeaturedSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitFeaturedSliders());
document.addEventListener('shopify:section:load', (event) => autoInitFeaturedSliders(event.target));
document.addEventListener('shopify:section:select', (event) => autoInitFeaturedSliders(event.target));


// blog slider//

function initBlogSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--blog-initialized')) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: '20px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1024: { perPage: 2 },
      768: { perPage: 1.2 },
      575: {
        perPage: 1,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });

  splide.mount();
  slider.classList.add('splide--blog-initialized');
}

function autoInitBlogSliders(scope = document) {
  scope.querySelectorAll('.blog-splide').forEach((slider) => {
    initBlogSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitBlogSliders());
document.addEventListener('shopify:section:load', (event) =>
  autoInitBlogSliders(event.target)
);
document.addEventListener('shopify:section:select', (event) =>
  autoInitBlogSliders(event.target)
);
function initRelatedProductsSplide(scope = document) {
  scope.querySelectorAll('product-recommendations').forEach((section) => {
    const splideEl = section.querySelector('.splide');

    if (!splideEl) return;
    if (splideEl.classList.contains('splide--related-initialized')) return;

    new Splide(splideEl, {
      type: 'slide',
      perPage: 4,
      gap: '20px',
      arrows: true,
      pagination: false,
      breakpoints: {
        1200: { perPage: 3 },
        990: { perPage: 2 },
        750: { perPage: 1 ,
          padding: { right: '100px', left: '0px' }
        },
      },
    }).mount();

    splideEl.classList.add('splide--related-initialized');
  });
}

/* Observe AJAX load */
const relatedObserver = new MutationObserver(() => {
  initRelatedProductsSplide();
});

document.addEventListener('DOMContentLoaded', () => {
  initRelatedProductsSplide();

  document.querySelectorAll('product-recommendations').forEach((el) => {
    relatedObserver.observe(el, { childList: true, subtree: true });
  });
});

document.addEventListener('shopify:section:load', (e) =>
  initRelatedProductsSplide(e.target)
);



function initCatagorySlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 6,
    perMove: 1,
    gap: '30px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1600: { perPage: 5 },
      1199: { perPage: 5 },
      1024: { perPage: 3, gap: '15px' },
      768: { perPage: 3 },
      575: {
        perPage: 2,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });

  splide.mount();

  slider.classList.add('splide--featured-initialized');
}

function autoInitCatagorySliders(scope = document) {
  scope.querySelectorAll('.catagories-splide').forEach((slider) => {
    initCatagorySlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitCatagorySliders());
document.addEventListener('shopify:section:load', (event) => autoInitCatagorySliders(event.target));
document.addEventListener('shopify:section:select', (event) => autoInitCatagorySliders(event.target));